import React from 'react';
import '../styles/VideoSection.css';

const VideoSection = () => {
  const videoId = 'w_xmmVrTAb0';
  const embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&autoplay=1&mute=1&controls=1&playsinline=1&enablejsapi=1&origin=${window.location.origin}`;

  return (
    <section className="video-section">
      <div className="container">
        <div className="video-wrapper">
          <div className="video-container">
            <iframe
              src={embedUrl}
              title="BBC Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="video-iframe"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;